import React from 'react';

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`bg-white border-2 rounded-3xl p-5 animate-pulse ${className}`} style={{ borderColor: '#E5DACE' }}>
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-[#F0E6D8]" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-[#F0E6D8] rounded w-3/4" />
          <div className="h-3 bg-[#F0E6D8] rounded w-1/2" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonStats() {
  return (
    <div className="grid grid-cols-3 gap-3 animate-pulse">
      {[0, 1, 2].map(i => (
        <div key={i} className="bg-white border-2 rounded-2xl p-3 text-center" style={{ borderColor: '#E5DACE' }}>
          <div className="h-6 bg-[#F0E6D8] rounded w-12 mx-auto mb-2" />
          <div className="h-3 bg-[#F0E6D8] rounded w-16 mx-auto" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonCalendar() {
  return (
    <div className="flex justify-between gap-1 animate-pulse">
      {[0, 1, 2, 3, 4, 5, 6].map(i => (
        <div key={i} className="flex-1 flex flex-col items-center gap-1">
          <div className="h-3 bg-[#F0E6D8] rounded w-6" />
          <div className="w-8 h-8 rounded-full bg-[#F0E6D8]" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonButton() {
  return (
    <div className="w-full h-16 rounded-3xl bg-[#F0E6D8] animate-pulse" />
  );
}

export function SkeletonChart() {
  return (
    <div className="bg-white border-2 rounded-3xl p-4 animate-pulse" style={{ borderColor: '#E5DACE' }}>
      <div className="h-4 bg-[#F0E6D8] rounded w-32 mb-3" />
      <div className="flex items-end gap-2 h-32">
        {[40, 70, 55, 85, 30, 60, 90].map((h, i) => (
          <div key={i} className="flex-1 bg-[#F0E6D8] rounded-t-lg" style={{ height: `${h}%` }} />
        ))}
      </div>
    </div>
  );
}

export function SkeletonList({ rows = 3 }) {
  return (
    <div className="bg-white border-2 rounded-3xl p-4 animate-pulse space-y-3" style={{ borderColor: '#E5DACE' }}>
      <div className="h-4 bg-[#F0E6D8] rounded w-32" />
      {Array(rows).fill(0).map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-[#F0E6D8]" />
          <div className="flex-1 h-3 bg-[#F0E6D8] rounded" />
          <div className="w-12 h-3 bg-[#F0E6D8] rounded" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonQuestion() {
  return (
    <div className="px-4 space-y-4 animate-pulse">
      <div className="h-3 bg-[#F0E6D8] rounded w-32" />
      <div className="h-2 w-full bg-[#F0E6D8] rounded-full" />
      <div className="bg-white border-2 rounded-3xl p-5 space-y-3" style={{ borderColor: '#E5DACE' }}>
        <div className="h-5 bg-[#F0E6D8] rounded w-full" />
        <div className="h-5 bg-[#F0E6D8] rounded w-3/4" />
      </div>
      {[0, 1, 2, 3].map(i => (
        <div key={i} className="bg-white border-2 rounded-2xl p-4 flex items-center gap-3" style={{ borderColor: '#E5DACE' }}>
          <div className="w-8 h-8 rounded-full bg-[#F0E6D8]" />
          <div className="h-4 bg-[#F0E6D8] rounded flex-1" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonChat() {
  return (
    <div className="space-y-4 animate-pulse px-4">
      <div className="flex gap-2">
        <div className="w-8 h-8 rounded-full bg-[#F0E6D8]" />
        <div className="bg-white border-2 rounded-2xl p-3 w-2/3" style={{ borderColor: '#E5DACE' }}>
          <div className="h-3 bg-[#F0E6D8] rounded w-full mb-2" />
          <div className="h-3 bg-[#F0E6D8] rounded w-3/4" />
        </div>
      </div>
      <div className="flex gap-2 justify-end">
        <div className="bg-[#FF6B35]/20 rounded-2xl p-3 w-1/2">
          <div className="h-3 bg-[#F0E6D8] rounded w-full" />
        </div>
      </div>
    </div>
  );
}
